/* eslint-disable import/order */
// eslint-disable-next-line import/no-unassigned-import
import './devtools-window-polyfill.js';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
import devtools from 'react-devtools-core';
// eslint-disable-next-line @typescript-eslint/no-unsafe-call
devtools.initialize();
// eslint-disable-next-line @typescript-eslint/no-unsafe-call
devtools.connectToDevTools();
//# sourceMappingURL=devtools.js.map